import React, { useState } from "react";
import { Modal } from "ui-components/modal";
import { $modals } from "../../../store/modals";
import { observer } from "mobx-react-lite";
import { LoadingButton } from "@mui/lab";
import { Alert, Typography, Box } from "@mui/material";
import { $fastOrderLinks } from "../../../store/fastOrderLinks";
import { $snackbar } from "../../../store/snackbar";

const DeleteDiscountModal = observer(() => {
  // Все хуки должны быть объявлены до любых условных возвратов
  const [btnLoading, setBtnLoading] = useState(false);
  
  const discount = $modals.deleteFastOrderDiscount.data;

  const deleteDiscount = () => {
    setBtnLoading(true);
    $fastOrderLinks
      .deleteDiscount(discount.id)
      .then(() => {
        $snackbar.show("Скидка успешно удалена", "success");
        $modals.deleteFastOrderDiscount.hide();
      })
      .catch(() => {
        $snackbar.show("Ошибка при удалении скидки", "error");
      })
      .finally(() => {
        setBtnLoading(false);
      });
  };

  // Условная проверка видимости после всех хуков
  if (!$modals.deleteFastOrderDiscount.visible || !discount) {
    return null;
  }

  return (
    <Modal
      title="Удалить скидку"
      subheader="Вы действительно хотите удалить скидку?"
    >
      <Typography variant="body1" sx={{ mb: 2 }}>
        <strong>ID товара:</strong> {discount.product_id || "-"}
      </Typography>
      
      <Typography variant="body1" sx={{ mb: 2 }}>
        <strong>Цена в ТБП:</strong> {discount.original_price ? `${discount.original_price} ₽` : "-"}
      </Typography>
      
      <Typography variant="body1" sx={{ mb: 3 }}>
        <strong>Цена со скидкой:</strong>{" "}
        {discount.discount_price && discount.original_price ? (
          <Box component="span" display="inline-flex" alignItems="center" gap={1}>
            <span>{discount.discount_price} ₽</span>
            <Typography component="span" color="error.main" fontWeight="bold">
              {Math.round(((discount.original_price - discount.discount_price) / discount.original_price) * 100)}%
            </Typography>
          </Box>
        ) : discount.discount_price ? (
          `${discount.discount_price} ₽`
        ) : (
          "-"
        )}
      </Typography>

      <Alert sx={{ mb: 3 }} severity="warning">
        Удаление скидки необратимо. Скидка больше не будет применяться к новым заказам.
      </Alert>

      <LoadingButton
        sx={{ float: "right" }}
        loading={btnLoading}
        variant="contained"
        color="error"
        onClick={deleteDiscount}
      >
        Удалить
      </LoadingButton>
    </Modal>
  );
});

export default DeleteDiscountModal;
